<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>
<ng-template #lazyLoadPanelContent>
  <div id="details-sub-panels" *ngIf="session | async; else noAccount">
    <hs-pricing-data-menu
      (beginDateEmitter)="setBeginDate($event)"
      (endDateEmitter)="setEndDate($event)"
      (sourceOptionEmitter)="setPriceSourceOption($event)"
      (accountIdWithSecurityId)="setAccountIdAndSecurityId($event)"
    ></hs-pricing-data-menu>
    <br />
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li [ngbNavItem]="1">
        <a ngbNavLink> Price Data </a>
        <ng-template ngbNavContent>
          <span *nfLoader="loadingpriceData">
            <pricing-data-by-source-table
              [pricingSource]="pricingSource"
              [priceData]="priceData"
              [securityIds]="securityIds"
              [lastPricingRunDate]="lastPricingRunDate"
              [hidden]="priceData.length == 0"
              [lastPrice]="lastPrice"
            ></pricing-data-by-source-table>
            <br />
            <nf-checkbox
              label="Enable Charts"
              [formControl]="chartsEnabled"
              [hidden]="priceData.length == 0"
            ></nf-checkbox>
            <div *ngIf="chartsEnabled.value && priceData.length != 0">
              <pricing-charts
                [priceData]="priceData"
                [beginDate]="beginDate"
                [endDate]="endDate"
              >
              </pricing-charts>
            </div>
            <div *ngIf="priceData.length == 0 && !securitySelected">
              <p>No Price Data Available. Please select a security</p>
            </div>
            <div *ngIf="priceData.length == 0 && securitySelected">
              <p>No Price Data Available</p>
            </div>
          </span>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink> Price Source Hierarchy ({{ endDate }}) </a>
        <ng-template ngbNavContent>
          <span *nfLoader="loadingPricingHierarchyData">
            <div *ngIf="pricingHierarchy.length > 0">
              <nf-table-layout
                hideTitle="true"
                [autoResizeGrid]="false"
                isSectionTitle="true"
                [data]="pricingHierarchy"
                [gridOptions]="gridOptionsPricingHierarchy"
                hideClearAll
              ></nf-table-layout>
            </div>
            <div *ngIf="pricingHierarchy.length == 0">
              <p>No Price Source Hierarchy Data Available</p>
            </div>
          </span>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a ngbNavLink> Available Price Sources </a>
        <ng-template ngbNavContent>
          <span *nfLoader="loadingAllAvailableSources">
            <div *ngIf="allAvailableSources.length > 0">
              <nf-table-layout
                hideTitle="true"
                [autoResizeGrid]="false"
                isSectionTitle="true"
                [data]="allAvailableSources"
                [gridOptions]="gridOptionsPricingSource"
                hideClearAll
              ></nf-table-layout>
            </div>
            <div *ngIf="allAvailableSources.length == 0">
              <p>No Available Price Source Data Available.</p>
            </div>
          </span>
        </ng-template>
      </li>
    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <br />
  </div>
  <div>
    <ng-template #noAccount>
      <hs-no-loaded-account></hs-no-loaded-account>
    </ng-template>
  </div>
</ng-template>
